import { withStyles, Button } from "@material-ui/core";
import React from "react";
import { Header, WithChatWindow } from "../../common";
import {
  Close as CloseButton,
  Message as CannedMessageButton,
  Urgent as UrgentButton,
  Delete as DeleteButton,
} from "../../common/Buttons";
import styles from "./styles";
import { compose } from "recompose";
import CustomTextField from "../../../RouteExecution/DriverPopUp/common/CustomTextField";
import RadioButton from "@material-ui/icons/RadioButtonUncheckedSharp";
import SendOutlinedIcon from "@material-ui/icons/SendOutlined";
import constants from "../../constants";

class MCQMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: this.props.selectedCannedMessage,
      isUrgent: false,
      choice: [],
      errorInfo: this.getDefaultErrorInfo(),
    };
  }

  componentDidUpdate(prevProps) {
    const { selectedCannedMessage } = this.props;
    if (selectedCannedMessage !== prevProps.selectedCannedMessage) {
      this.handleChange("message")(selectedCannedMessage);
    }
  }

  getDefaultErrorInfo = () => {
    return {
      message: "",
      choice: "",
    };
  };

  getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(this.state.errorInfo).forEach((fieldName) => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state[fieldName],
      );
    });
    this.setState({
      errorInfo,
    });
    return errorInfo;
  };

  getFieldError = (field, value) => {
    switch (field) {
      case "message":
        return value && value.trim() ? null : "* Required";
      case "choice":
        return value && value.filter(Boolean).length > 0
          ? null
          : "* At least one option is required";
      default:
        return null;
    }
  };

  onSendMessage = () => {
    const { message, isUrgent, choice } = this.state;
    const errorInfo = this.getErrorInfo();
    const error = Object.values(errorInfo).filter((value) => value).length;
    if (!error) {
      this.props.onMessageSubmit({
        message,
        isUrgent,
        choice: choice.filter(Boolean),
      });
    }
  };

  handleChange = (name) => (value) => {
    this.setState((prevState) => ({
      [name]: value,
      errorInfo: {
        ...prevState.errorInfo,
        [name]: this.getFieldError(name, value),
      },
    }));
  };

  handleOptionChange = (index) => (value) => {
    const prevOptions = this.state.choice;
    prevOptions[index] = value;
    this.setState((prevState) => ({
      choice: [...prevOptions],
      errorInfo: {
        ...prevState.errorInfo,
        choice: this.getFieldError("choice", prevOptions),
      },
    }));
  };

  handleDeleteOption = (index) => {
    const prevOptions = this.state.choice;
    prevOptions.splice(index, 1);
    this.setState({
      choice: [...prevOptions],
    });
  };

  onAddOption = () => {
    this.setState((prevState) => ({
      ...prevState,
      choice: [...prevState.choice, ""],
    }));
  };

  markUrgentMessage = () => {
    this.setState((prevState) => ({
      ...prevState,
      isUrgent: !prevState.isUrgent,
    }));
  };

  render() {
    const { classes, handleChoiceMessageClick, showCannedMessages } =
      this.props;
    const { isUrgent } = this.state;
    return (
      <>
        <Header title="Multiple Options">
          <CloseButton onClick={() => handleChoiceMessageClick(false)} />
        </Header>
        <div className={`${classes.mcqContainer} customScroll`}>
          <div className={classes.flexRow}>
            <CustomTextField
              id="message"
              autoFocus
              className={classes.fullWidth}
              value={this.state.message}
              handleChange={this.handleChange("message")}
              InputPropsClasses={{
                input: classes.messageInputField,
                multiline: classes.textFieldMultiline,
              }}
              placeholder="Write question"
              multiline
              error={this.state.errorInfo.message}
              rows={3}
            />
          </div>
          <div className={classes.buttonGroup}>
            <CannedMessageButton onClick={showCannedMessages} />
            <UrgentButton
              onClick={this.markUrgentMessage}
              isMarkedAsUrgent={isUrgent}
            />
          </div>
          {this.state.choice.map((option, index) => (
            <div className={classes.radioStyle}>
              <RadioButton className={classes.radioIcon} />
              <CustomTextField
                id="message"
                value={option}
                handleChange={this.handleOptionChange(index)}
                InputPropsClasses={{
                  input: classes.optionInputField,
                }}
                variant="standard"
                className={classes.textField}
                inputProps={{
                  maxLength: constants.MAX_LENGTH_CONSTRAINTS.OPTION_TEXT,
                }}
              />
              <DeleteButton id={index} onDelete={this.handleDeleteOption} />
            </div>
          ))}
          <div className={classes.optionContainer}>
            <Button
              variant="text"
              color="primary"
              onClick={this.onAddOption}
              id="addNewOption"
              size="small"
              className={classes.addOption}
              disabled={
                this.state.choice.length >=
                constants.MCQ_MESSAGE_CONSTRAINTS.MAX_ALLOWED_OPTIONS
              }
              disableRipple
            >
              + add option
            </Button>
            {Boolean(this.state.errorInfo.choice) && (
              <span className={classes.errorMsg}>
                {this.state.errorInfo.choice}
              </span>
            )}
          </div>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onSendMessage}
            id="sendMessage"
            size="small"
            className={classes.sendMessage}
            disableRipple
          >
            SEND <SendOutlinedIcon className={classes.iconStyle} />
          </Button>
        </div>
      </>
    );
  }
}

export default compose(withStyles(styles), WithChatWindow)(MCQMessage);
